export const projects = [
  {
    startDate: "Feb 2026",
    endDate: "Present",
    title: "Replay Codes Bot",
    description: "A Discord bot that uses AI vision to extract Overwatch replay codes from screenshots and automatically logs them to Google Sheets. Also manages team schedules and player availability for coordinating practice sessions (scrims).",
    link: "https://github.com/andyjsiegel/Replay-Codes-Bot",
    tags: ["Python", "Discord.py", "Google Sheets API"],
  },
  {
    startDate: "Jun 2023",
    endDate: "Present",
    title: "Raycast Custom Extensions",
    description: "Creating extensions for Raycast to improve my own productivity. This involved both creating extensions from scratch and forking existing ones to better suit my use-cases.",
    link: null,
    tags: ["React.js", "TypeScript", "Node.js"],
  },
  {
    startDate: "Mar 2025",
    endDate: "Apr 2025",
    title: "Java Swing Gradebook Application",
    description: "A desktop application for managing courses, students, and grades, featuring user authentication and data persistence using CSV files.",
    link: "https://github.com/andyjsiegel/CSC-335-Final-Project",
    tags: ["Java", "Java Swing", "Agile"],
  },
  {
    startDate: "Mar 2025",
    endDate: "Mar 2025",
    title: "Music Store Management Application",
    description: "A text-based UI simulating a music store where users can manage a music library, create playlists, and rate songs.",
    link: "https://github.com/kdchafin/CSC335_MusicStore",
    tags: ["Java", "Agile Development"],
  },
  {
    startDate: "Nov 2024",
    endDate: "Dec 2024",
    title: "Grade Calculator",
    description: "A weighted grade calculator originally built as a Raycast extension, now available as a web app. Computes final grades from CSV-style input, supporting percentages, fractions, and decimals.",
    link: "/grade-calculator",
    tags: ["React.js", "TypeScript"],
  },
  {
    startDate: "Sep 2024",
    endDate: "Oct 2024",
    title: "Akiflow Capture Script",
    description: "A context-aware script that automatically organizes tasks for the Akiflow productivity app based on the frontmost application and URL.",
    link: "https://github.com/andyjsiegel/Akiflow-Capture",
    tags: ["Python"],
  },
  {
    startDate: "Sep 2024",
    endDate: "Sep 2024",
    title: "Registrar Calendar Downloader",
    description: "A Python script to scrape the University of Arizona's registrar calendar and generate an .ics file for easy import into calendar applications.",
    link: "https://github.com/andyjsiegel/Registrar-Calendar-Downloader",
    tags: ["Python", "Selenium", "BeautifulSoup"],
  },
  {
    startDate: "Jan 2022",
    endDate: "Jul 2023",
    title: "YTPT Bot",
    description: "A general-purpose Discord bot for schedule coordination, providing daily school schedules and managing work shifts.",
    link: "https://github.com/andyjsiegel/YTPT-Bot",
    tags: ["JavaScript", "Discord.js"],
  },
];


export const experience = [
  {
    startDate: "Jan 2026",
    endDate: "Present",
    title: "Teaching Assistant for CSC 144 - Discrete Mathematics",
    company: "University of Arizona",
  },
  {
    startDate: "Jan 2025",
    endDate: "Present",
    title: "eSports Arena Student Staff",
    company: "University of Arizona",
  },
  {
    startDate: "May 2025",
    endDate: "Aug 2025",
    title: "Software Engineer Intern",
    company: "State Farm",

  },
  {
    startDate: "Jun 2022",
    endDate: "Mar 2023",
    title: "Cook / Cashier",
    company: "10 PIZZA",
  },
];

export const education = [
  {
    startDate: "Aug 2023",
    endDate: "Dec 2026",
    school: "University of Arizona",
    degree: "B.S. Computer Science, Math Minor",
    courses: [
      { code: "CSC 473", name: "Automata, Grammars and Languages" },
      { code: "CSC 436", name: "Software Engineering", link: "https://github.com/VohidovTohirjon/voice-to-text-openemr" },
      { code: "CSC 352", name: "Systems Programming & Unix" },
      { code: "CSC 345", name: "Data Structures & Algorithms" },
      { code: "CSC 335", name: "Object Oriented Programming" },
      { code: "ISTA 322", name: "Data Engineering", link: "https://github.com/andyjsiegel/ISTA-322/" },
    ],
  },
];

export const skills = {
  languages: ["JavaScript", "TypeScript", "Python", "Java"],
  frameworks: ["React.js", "Node.js", "Java Swing"],
  tools: ["Git", "GitHub", "Docker", "Selenium", "Agile Development"],
};

// Configuration for link previews on hover
export const linkPreviewConfig = {
  // To override a favicon with a custom image, provide the path to your image.
  '1password.com': '/images/1Password.png',
  'www.arc.net': '/images/Arc.png',
  'copilot.money': '/images/Copilot.png',
  'sindresorhus.com': '/images/Dato.png',
  'www.noodlesoft.com': '/images/Hazel.png',
  'www.tana.inc': '/images/Tana.png',
  'superhuman.com': '/images/Superhuman.png',
  'github.com': null, // Hiding this preview

  // To hide a preview for a specific domain, set its value to null.
  'x.com': null,
  'twitter.com': null,
};

// A list of specific URLs that should have the link preview feature enabled.
export const previewableLinks = [
  'https://www.arc.net',
  'https://www.alfredapp.com/',
  'https://raycast.com/?via=andyjsiegel',
  'https://github.com/mxstbr/karabiner',
  'https://karabiner-elements.pqrs.org/',
  'https://superhuman.com/refer/ke629ags',
  'https://www.warp.dev',
  'https://www.notion.com/',
  'https://www.todoist.com/',
  'https://amie.so/',
  'https://www.routine.co/',
  'https://akiflow.com/',
  'https://anytype.io/',
  'https://www.tana.inc/',
  'https://x.com/tana_inc/status/1575838024579002368',
  'https://www.notion.com/product/calendar',
  'https://www.risecalendar.com/',
  'https://1password.com/',
  'https://www.beeper.com/',
  'https://copilot.money/',
  'https://www.noodlesoft.com/',
  'https://sindresorhus.com/dato',
  'https://tryalcove.com/',
  'https://syncthing.net/',
];

